import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TableImage from "../../shared/Table/TableImage";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/adminPermissions";
import { exportTableToCsv } from "../../utils/exportTableCsv";

export default function StaticPageTable({ heading, allStaticPages, loading, history, search, setSearch, onDelete }) {
    const [selectedRow, setSelectedRow] = useState([]);
    const { userProfile } = useSelector((state) => state.profile);
    const canUpdate = hasPermission(userProfile, "static_pages.update");

    const actions = (d) => {
        return (
            <div className="flex justify-content-around">
                <i className="pi pi-eye cursor-pointer text-dark" onClick={() => history(`/static-page/view/${d._id}`)}></i>
                {canUpdate && <i className="pi pi-pencil cursor-pointer text-dark ml-2 mr-2" onClick={() => history(`/static-page/edit/${d._id}`)}></i>}
                {/* <i className="pi pi-trash cursor-pointer text-dark" onClick={() => onDelete(d._id)}></i> */}
            </div>
        );
    };

    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => {
                    options.filterCallback(e.value, options.index);
                }}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                mask="99/99/9999"
            />
        );
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    const formatDate = (date) => {
        return date?.toLocaleDateString?.("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const exportAll = () => {
        exportTableToCsv("static-pages.csv", allStaticPages, [
            { header: "Title", value: "title" },
            { header: "Date", value: (row) => (row.time ? formatDate(row.time) : "-") },
        ]);
    };

    return (
        <>
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-between mb-4">
                        <h5>{heading}</h5>
                        {/* {setSearch ? (
                            <div className="p-input-icon-left mx-2">
                                <i className="pi pi-search" />
                                <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" /> */}
                        {/* <PrimaryButton onClick={() => history(`/static-page/add`)}>Add Static Page</PrimaryButton> */}
                        {/* </div>
                        ) : null} */}
                        <PrimaryButton
                            label="Export CSV"
                            icon="pi pi-download"
                            onClick={exportAll}
                            disabled={!allStaticPages.length}
                            severity="success"
                        />
                    </div>
                    <DataTable
                        paginator
                        value={allStaticPages}
                        selection={selectedRow}
                        onSelectionChange={(e) => setSelectedRow(e.value)}
                        selectionMode="checkbox"
                        filter={filters}
                        filterDisplay="menu"
                        rows={10}
                        loading={loading}
                        emptyMessage="No Static Page found."
                        className=""
                        showGridlines
                    >
                        <Column field="title" header="Title"></Column>
                        <Column
                            header="Date"
                            field="time"
                            dataType="date"
                            style={{ width: "150px" }}
                            filterMatchMode="dateIs"
                            showFilterMatchModes={true}
                            body={(rowData) => formatDate(rowData.time)}
                            filter
                            filterElement={dateFilterTemplate}
                        />
                        <Column body={actions} style={{ width: "80px" }} header="Action"></Column>
                    </DataTable>
                </div>
            </div>
        </>
    );
}
